export default __webpack_public_path__ + "static/media/atletasmx.f3314dc9.png";